// ** Icon Imports
import Icon from 'src/@core/components/icon'
import { useTranslation } from 'src/utils/i18n'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { redirectGuideAddNewDevice } from 'src/utils/chooseDeviceRedirect'

const Header = ({ hiddenLang }) => {
  const { t, changeLocale, locale } = useTranslation('common')
  const [isNavigating, setIsNavigating] = useState(false)

  const router = useRouter()

  const handleLangItemClick = lang => {
    router.push(
      {
        route: router.pathname,
        query: router.query
      },
      router.asPath,
      { locale: lang }
    )

    changeLocale(lang)
  }

  const handleAddNewDeviceClick = async () => {
    if (isNavigating) return

    setIsNavigating(true)

    try {
      await redirectGuideAddNewDevice()
    } finally {
      setIsNavigating(false)
    }
  }

  return (
    <>
      <div className='w-full h-[80px] Bld:h-[60px] Bxl:pl-[16px] bg-[#06273D] fixed top-0 z-50'>
        <div className='max-w-[1200px] h-full mx-auto flex justify-between items-center px-4 Bld:px-4'>
          <Image
            className='mb-[6px] Bld:w-[90px] cursor-pointer'
            src='/images/msafely-wordmark.svg'
            width={130}
            height={32}
            alt='msafely'
            onClick={() => router.push('/')}
          ></Image>
          <div className='flex items-center gap-2'>
            <button
              type='button'
              disabled={isNavigating}
              className='flex h-[40px] items-center justify-center rounded-[10px] px-[15px] text-[15px] font-[600] text-[#FFF] transition-colors hover:bg-[#FFF] hover:text-[#2a99ff] disabled:cursor-not-allowed disabled:opacity-70'
              onClick={handleAddNewDeviceClick}
            >
              {t('Add New Device')}
            </button>
            {!hiddenLang && (
              <div className='w-[86px] h-[40px] pl-[7px] rounded-[10px] flex justify-center items-center text-[#FFF] text-[15px] font-[600] hover:text-[#2a99ff] hover:bg-[#FFF] relative group'>
                <span>
                  {locale == 'it-ch' ? 'It' : locale.charAt(0).toUpperCase() + locale.slice(1)}
                </span>
                <Icon icon='ic:round-keyboard-arrow-down' />
                <div className='absolute right-0 top-[40px] pt-[10px] hidden group-hover:flex hover:flex flex-col'>
                  <div className='w-[150px] py-[5px] bg-[#FFF] rounded-[10px] shadow-2xl'>
                    {[
                      { img: '/images/lang/en.svg', text: 'English', lang: 'en' },
                      { img: '/images/lang/es.svg', text: 'Español', lang: 'es' },
                      { img: '/images/lang/de.svg', text: 'Deutsch', lang: 'de' },
                      { img: '/images/lang/fr.svg', text: 'Français', lang: 'fr' },
                      { img: '/images/lang/it.svg', text: 'Italiano', lang: 'it-ch' },
                      { img: '/images/lang/pt.svg', text: 'Português', lang: 'pt' },
                      { img: '/images/lang/jp.svg', text: '日本語', lang: 'jp' },
                      { img: '/images/lang/kr.svg', text: '한국어', lang: 'kr' }
                    ].map((item, index) => (
                      <div
                        key={index}
                        className={`${locale === item.lang ? 'text-[#2a99ff]' : 'text-[#222]'
                          } w-full flex justify-center hover:text-[#2a99ff] cursor-pointer`}
                        onClick={() => handleLangItemClick(item.lang)}
                      >
                        <div className='w-[85px] py-[10px] flex items-center text-[16px] font-[400]'>
                          {item.text}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='w-full h-[80px] Bld:h-[60px]'></div>
    </>
  )
}

export default Header
